import { render, staticRenderFns } from "./benefits.vue?vue&type=template&id=1510b75c&scoped=true&"
import script from "./benefits.vue?vue&type=script&lang=js&"
export * from "./benefits.vue?vue&type=script&lang=js&"
import style0 from "./benefits.vue?vue&type=style&index=0&id=1510b75c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1510b75c",
  null
  
)

export default component.exports